import {styled} from '@innowise-group/ui-kit';

interface AttendanceFloorBadgeProps {
  backgroundColor: string;
  color: string;
}

export const AttendanceFloorPercentage = styled.div<AttendanceFloorBadgeProps>`
  font-size: 16px;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 7px;
  background-color: ${({backgroundColor}) => backgroundColor};
  color: ${({color}) => color};
`;

export const AttendanceOfficeTitle = styled.div<{attendanceType: 'room' | 'office'}>`
  font-size: 14px;
  font-weight: 500;
  padding-left: ${({attendanceType}) => (attendanceType === 'room' ? 0 : '5px')};
  display: flex;
  align-items: center;
  gap: 12px;
`;
